import { render, staticRenderFns } from "./QuestionLayout.vue?vue&type=template&id=2e08cf1d&scoped=true&"
import script from "./QuestionLayout.vue?vue&type=script&lang=ts&"
export * from "./QuestionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionLayout.vue?vue&type=style&index=0&id=2e08cf1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08cf1d",
  null
  
)

export default component.exports